<h2 mat-dialog-title>{{ 'warning' | translate}}</h2>
<mat-dialog-content style="display: flex; flex-direction: column; justify-content: start;">
    <p>{{ data.infoText | translate }}</p>
    <p>{{'writeToContinue' | translate}}: <strong>{{ data.wordToRepeat }}</strong></p>
    <mat-form-field style="align-self: center; font-size: 24px;">
        <input matInput [(ngModel)]="userRepeat" />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close(false)">{{ 'cancel' | translate}}</button>
    <button mat-button [disabled]="!isEqual(data.wordToRepeat, userRepeat)" (click)="confirm()">{{ 'confirm' | translate}}</button>
</mat-dialog-actions>